import { isEnumMember } from 'typescript';
import * as yup from 'yup';

import parsePlacesResult from 'utils/parsePlacesResult';

const initialValues = {
  name: '',
  type: '',
  site: '',
  address: {
    addressLine1: '',
    addressLine2: '',
    city: '',
    state: '',
    zip: '',
  },
  code: '',
  washHub: '',
  pickupFrequency: '',
  pickupDayOfTheWeek: [],
  deliveryInstructions: '',
};

const validationSchema = yup.object().shape({
  name: yup.string().required('Name is a required field'),
  type: yup.string(),
  site: yup.string(),
  washHub: yup.string(),
  address: yup
    .object()
    .typeError('Address is a required field')
    .shape({
      addressLine1: yup.string(),
      addressLine2: yup.string(),
      city: yup.string(),
      state: yup.string(),
      zip: yup
        .string()
        .required('Zip code is a required field')
        .matches(/^[0-9]*$/, 'Invalid format (zip code must be a number).'),
    })
    .required('Address is a required field'),
  pickupFrequency: yup
    .string()
    .required('Pickup Frequency is a required field'),
  pickupDayOfTheWeek: yup.array(),
  deliveryInstructions: yup.string(),
});

const parseGoogleGeocoderResultIntoAddressComponents = (
  queryResult: google.maps.GeocoderResult[] = [],
): any => ({
  // addressLine1 is the street and addressLine2 the unit Google gave, if any
  // (ClickUp 86bcgvh8k).
  ...parsePlacesResult(queryResult as any),
});

export {
  initialValues,
  validationSchema,
  parseGoogleGeocoderResultIntoAddressComponents,
};
